import { Box, Card, CardContent, Grid, Typography, Stack, Button } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { IDetalheProdutoEstoque } from "../../../../../../../types/api/estoque/detalhar-produto-estoque";
import { DadoValorPrinter } from "../../../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";
import {useState} from "react";
import DialogEditInformacoesBasicas from "../CardInformacoesBasicas/DialogEditInformacoesBasicas";
import DialogEditEspecificacoesTecnicas from "./DialogEditEspecificacoesTecnicas";
import {formatNumber} from "chart.js/helpers";

export default function CardEspecificacoesTecnicas({
                                                       produto,
                                                   }: {
    produto: IDetalheProdutoEstoque;
}) {
    const [openEdit, setOpenEdit] = useState(false);

    const tipoProdutoLabel: Record<string, string> = {
        P: "Produto",
        S: "Serviço",
        I: "Ativo Imobilizado",
        C: "Consumo",
        T: "Produto Terceiro"
    };


    return (
        <Card>
            <CardContent>
                <Box>
                    <Typography variant="h6" gutterBottom>
                        Especificações Técnicas
                    </Typography>
                    <Grid container spacing={2}>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter
                                titulo="Tipo"
                                valor={tipoProdutoLabel[produto.tipo_produto as keyof typeof tipoProdutoLabel] || "-"}
                            />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Unidade" valor={produto.unidade_medida?.sigla ?? "-"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Permite Decimais?" valor={produto.aceita_decimal === "S" ? "Sim" : "Não"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Unid. Padrão Etiqueta" valor={produto.unidade_padrao_etiqueta?.sigla ?? "-"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Quant. Unid. Padrão" valor={String(produto.quantidade_padrao_etiqueta) ?? "-"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Unid. Fator Conversão" valor={produto.unidade_fator_conversao?.sigla ?? "-"} />
                        </Grid>
                        <Grid size={{xs: 12, md: 4}}>
                            <DadoValorPrinter titulo="Quant. Fator Conversão" valor={String(produto.quantidade_fator_conversao) ?? "-"} />
                        </Grid>
                    </Grid>
                    <Stack direction="row" spacing={2} mt={2} justifyContent="flex-end">
                        <Button
                            size="small"
                            variant="outlined"
                            color="primary"
                            startIcon={<EditIcon />}
                            onClick={() => setOpenEdit(true)}
                        >
                            Editar
                        </Button>
                    </Stack>
                </Box>
            </CardContent>
            <DialogEditEspecificacoesTecnicas
                open={openEdit}
                onClose={() => setOpenEdit(false)}
                produto={produto}
            />
        </Card>
    );
}